import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';

export interface UpdateAndRecalculatedSalePatternsWithProductCommandParams {
    productId: number;
    templates: RecalculateDocumentTemplateData[];
}

export interface RecalculateDocumentTemplateData {
    templateId: number;
    items: number[];
}

export interface UpdateAndRecalculatedSalePatternsWithProductCommandResult {
    id: number;
    name: string;
    success: boolean;
}

export class UpdateAndRecalculatedSalePatternsWithProductCommand extends Command<UpdateAndRecalculatedSalePatternsWithProductCommandParams, UpdateAndRecalculatedSalePatternsWithProductCommandResult[]> { }

export class UpdateAndRecalculatedSalePatternsWithProductCommandHandlerBase implements CommandHandler<UpdateAndRecalculatedSalePatternsWithProductCommand, UpdateAndRecalculatedSalePatternsWithProductCommandParams, UpdateAndRecalculatedSalePatternsWithProductCommandResult[]> {
    private static Url = TaggedUrl.join('documentTemplates/recalculate', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync({ params }: UpdateAndRecalculatedSalePatternsWithProductCommand): Promise<UpdateAndRecalculatedSalePatternsWithProductCommandResult[]> {
        const { data } = await this.http.post<UpdateAndRecalculatedSalePatternsWithProductCommandResult[]>(UpdateAndRecalculatedSalePatternsWithProductCommandHandlerBase.Url, params, { timeout: MS_PER_MINUTE });
        return data;
    }
}
